import type * as BasketUpdated from '@ori-events/basket-updated';
import * as ShoppingContextLoaded from '@ori-events/shopping-context-loaded';

import { convertToCamelCase, getHttpRequestSettings } from '../helpers';
import { RequestMethod, RequestUrl } from '../models';

export default async () => {
  const request = await fetch(
    RequestUrl.GetShoppingContext,
    getHttpRequestSettings(undefined, RequestMethod.Post),
  );

  const shoppingContext = convertToCamelCase<BasketUpdated.Data>((await request.json()) as object);

  const event = new CustomEvent<BasketUpdated.Data>(ShoppingContextLoaded.Name, {
    detail: shoppingContext,
  });
  window.dispatchEvent(event);

  return shoppingContext;
};
